import { Text } from '@dixa/lib-shared-habla';

/** Details for anonymous authentication. */
export function AnonymousDetails(): JSX.Element {
  return (
    <Text.Paragraph>
      The user can start a conversation as anonymous.
    </Text.Paragraph>
  );
}
